export default {
  default: () => import("/vercel/path0/apps/app/layouts/default.vue").then(m => m.default || m)
}